import Vue from "vue";
import Vuex from "vuex";
import gateway from "@/services/gateway";
import errors from "@/services/errors";
//import axios from "axios";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    subscription: null,
    customer: null,
    cardDetails: null
  },
  mutations: {
    SET_SUBSCRIPTION(state, payload) {
      state.subscription = payload;
    },
    SET_CUSTOMER(state, payload) {
      state.customer = payload;
    },
    SET_CARD_DETAILS(state, payload) {
      state.cardDetails = payload;
    }
  },
  actions: {
    async load({ commit }, token) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(
          `/public/subscriptions/${token}`
        );
        const x = 10;
        if (!res || res.status != 200)
          throw new Error("No se pudo cargar la suscripción.");
        commit("SET_SUBSCRIPTION", res.data);
        return null;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async subscribe(
      { commit },
      { paymentFormPayload, customerFormPayload, linkToken, recaptcha }
    ) {
      //PRE: precisa un captcha v2, los datos de la tarjeta y el email del usuario que esta haciendo la suscripción
      //POST:
      //1) llama al backend subscribeStep1 que corrobora el captcha y crea el usuario(si no existe) y la transacción vacia
      //2) llama al a)tokens, b)payments y c)cardtokens de decidir para guardar la tarjeta y tomar el token
      //3) llama el backend subscribeStep2 que termina de ingresar los datos de transacción inicial ($1) y los datos de la tarjeta

      try {
        //PASO 1: ingreso los datos de la tarjeta en el tokenizador de decidir y valido
        //que los datos de la tarjeta sean válidos

        const x = 10;
        /*
        const tokenRes = await gateway.createTempToken(this.cardSelectedId, {
          cardName: customerFormPayload.cardName,
          cardNumber: customerFormPayload.cardNumber,
          expirationDate: customerFormPayload.expirationDate,
          CVC: customerFormPayload.CVC
        });
        if (tokenRes.status != 201) {
          tokenRes.errorName = "DecidirGatewayError";
          const err = errors.handleHTTPError(tokenRes);
          throw err;
        }
        */

        //const y = 10;

        //PASO 2: creo el usuario, la tarjeta y la transacción en el backend para
        //tener un userId y transactionId
        const subscribeRes = await Vue.prototype.$axios.post(
          "/public/subscribe",
          {
            firstName: customerFormPayload.firstName || null,
            lastName: customerFormPayload.lastName || null,
            email: customerFormPayload.email,
            phone: customerFormPayload.tel || null,
            DNI: customerFormPayload.DNI || null,
            recaptcha,
            linkToken,
            cardToken: paymentFormPayload.tempCardToken,
            paymentCourierId: paymentFormPayload.paymentCourierId,
            cardSecurityCode: paymentFormPayload.CVC,
            cardBin: paymentFormPayload.bin,
            lastFourDigits: paymentFormPayload.lastFourDigits,
            expirationDate: paymentFormPayload.expirationDate,
            cardName: paymentFormPayload.cardName,
            cardDNI: paymentFormPayload.cardDNI
          }
        );
        if (subscribeRes.status != 201) {
          const err = errors.handleHTTPError(subscribeRes);
          throw err;
        }
        const z = 10;
        return subscribeRes.data;
      } catch (err) {
        throw err;
      }
    }
  },
  getters: {
    subscriptions: state => {
      const subscriptions = {
        results: state.results,
        pagination: state.pagination
      };
      return subscriptions;
    },
    customer: state => {
      return state.customer;
    }
  }
};
